import {
	DestroyRef,
	Directive,
	effect,
	inject,
	Injector,
	input,
} from '@angular/core'
import { FormControlManager } from '../data/form-control-manager.js'
import { FormControl } from '@angular/forms'
import { Subscription } from 'rxjs'
import {
	HasChangedInternallySymbol,
	HasInternalChangeObservable,
} from '@lg/shared'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { MatSelect } from '@angular/material/select'

@Directive({
	selector: '[lgFormComponent]',
	// selector: '[lgFormValue][lgFormComponent]',
	standalone: false,
})
export class FormCompomentForObjectDirective {
	private destroyRef = inject(DestroyRef)
	private subscription?: Subscription

	readonly lgFormComponent = input.required<any>()
	readonly lgFormValue = input.required<any>()

	constructor() {
		effect(() => {
			this.subscription?.unsubscribe()

			const valueWithInternalChanges =
				this.lgFormValue() as HasInternalChangeObservable
			this.subscription = valueWithInternalChanges?.[
				HasChangedInternallySymbol
			]?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
				const formComponent = this.lgFormComponent()
				if (formComponent instanceof MatSelect) {
					;(formComponent as any)._value = null // UNSAFE: meddle with internally stored value in order to force update
					formComponent.writeValue(valueWithInternalChanges)
				}
			})
		})
	}
}
